import * as TimingFunctions from './timing-functions';

export function animate({duration, draw, timing = 'linear', infinity}: {
    duration: number,
    draw: (progress: number) => void,
    timing?: keyof typeof TimingFunctions | ((timeFraction: number) => number),
    infinity?: boolean,
}) {
    const timingFunction = (typeof timing === 'string') ?
        TimingFunctions[timing] :
        timing;

    let start = performance.now();

    let requestId = requestAnimationFrame(function animate(time) {
        const timeFraction = Math.min(1, (time - start) / duration);
        const progress = timingFunction(timeFraction);

        draw(progress);

        if (timeFraction < 1 || infinity) {
            requestId = requestAnimationFrame(animate);

            if (timeFraction === 1) {
                start = performance.now();
            }
        }
    });

    return () => cancelAnimationFrame(requestId);
}
